import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { L1L3AuthService } from 'ngx-auth-util-lib';
import { DomainType, HekaAccountMenu, MultiDomainProfile } from 'ngx-heka-design-lib';
import { environment } from 'src/environments/local/environment';
import { UtilService } from './util.service';
import { BehaviorSubject } from 'rxjs';
import { multiDomainMgmtRoute } from '../models/multi-domain';

@Injectable({
  providedIn: 'root'
})
export class AccountMenuService {

  constructor(
    private authService: L1L3AuthService,
    private translateService: TranslateService,
    private utilService: UtilService,
    private router: Router
  ) {}

  public buildAccountMenu(profile: MultiDomainProfile): HekaAccountMenu {
    const userInfo = this.authService.getUserInfo();
    const currentProfile = profile.domains.find(d => d.active);
    const validDomains = profile.domains.filter(d => d.domainType == DomainType.JOINED);

    return {
      companyName: currentProfile?.companyName || '',
      userFullName: userInfo.display_name,
      userEmail: userInfo.email,
      userDomains: validDomains,
      profile: {
        label: this.translateService.instant('ACCOUNT_MENU.PROFILE'),
        clickHandler: () => this.authService.goToProfile()
      },
      domains: {
        label: this.translateService.instant('ACCOUNT_MENU.DOMAINS'),
        clickHandler: () => this.router.navigate([multiDomainMgmtRoute])
      },
      imprint: {
        label: this.translateService.instant('ACCOUNT_MENU.IMPRINT'),
        clickHandler: () =>
          this.utilService.goToLink(environment.links.applications.mh2 + environment.imprint.endpoint.paths.imprint)
      },
      help: {
        label: this.translateService.instant('ACCOUNT_MENU.HELP'),
        clickHandler: () =>
          this.utilService.goToLink(environment.links.help)
      },
      logout: {
        label: this.translateService.instant('ACCOUNT_MENU.LOGOUT'),
        clickHandler: () => this.authService.logout()
      }
    };
  }
}
